import { css } from 'lit-element';
const style = css`
.dropdown {
  --fc-popover-padding: 5px;
  --fc-popover-border-radius: 15px;
  --fc-form-field-default-width: fit-content;
  font-size: var(--fc-form-field-font-size, var(--fc-form-field-default-font-size));
}

.dropdown-button {
  --fc-icon-size: 14px;
  --fc-button-height: 28px;
  --fc-button-min-width: var(--fc-form-field-width, var(--fc-form-field-default-width));
  --fc-icon-fill: var(--ftr-apply);
  --fc-button-font-size: var(--fc-form-field-font-size, var(--fc-form-field-default-font-size));
  --fc-button-font-weight: normal;
  --fc-button-color: var(--gray-7);
  --fc-button-border: 1px solid transparent;
}
.dropdown-button:focus {
  --fc-button-color: var(--blue-5);
}

.dropdown-button[disabled] {
  pointer-events: none;
  cursor: default;
}

.dropdown-item {
  width: var(--fc-form-field-width, var(--fc-form-field-default-width));
  font-size: var(--fc-form-field-font-size, var(--fc-form-field-default-font-size));

  --fc-popover-item-padding: 5px;
}

.dropdown-item-clear {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.dropdown-container > fc-popover-item:not(:last-child) {
  margin-bottom: 2px;
}`;
export default style;
